<template>
    <div class="content mt-3 mt-md-4">
        <div class="container instagram-share__container text-center">
            <div class="row">
                <div class="col">
                    <h1>I just played 99Math with<br />
                        <strong>{{ friendName }}</strong>
                    </h1>
                </div>
            </div>
            <div class="row mt-1">
                <div class="col">
                    <img :src="`/images/${celebrityInvite}pic.png`" :title="friendName" :alt="friendName" />
                </div>
            </div>
            <div class="row mt-3">
                <div class="col">
                    <h3>Try it yourself at challenge.99math.com</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            friendName: {
                type: String,
                required: false,
            },
            celebrityInvite: {
                type: String,
                required: false,
            },
        },
        mounted() {
            if (!this.celebrityInvite) {
                this.$router.push('/');
            } else {
                this.$bvModal.msgBoxOk('Take a screenshot and post it to your Instagram stories!');
            }
        },
    }

</script>

<style lang="scss" scoped>
    .instagram-share__container {
        img {
            max-height: 200px;
            width: 95%;
            max-width: 200px;
            margin: 10px;
        }
        @media (min-width: 767px) {
            img {
                max-height: 350px;
                max-width: 350px;
            }
        }
    }
</style>
<style>
    .modal-body {
        color: #000;
    }
</style>
